import { HttpClient } from '@angular/common/http';
import { compact, keys, toLower, trim } from 'lodash';
import { environment } from '@env/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(protected http: HttpClient) {}

  protected endpoint(...args: any[]) {
    const fragments = compact(args);
    return `${environment.proxyApiURL}/${fragments.join('/')}`;
  }

  protected directEndpoint(...args: any[]) {
    const fragments = compact(args);
    return `${environment.proxyDirectUrl}/${fragments.join('/')}`;
  }

  protected patchMapColumnNames(payload: any, columnNames: string[]) {
    const props = keys(payload);
    const newPayload: Record<string, string> = {};
    props.forEach((p) => {
      const columnName = columnNames.find((c) => trim(toLower(p)) === trim(toLower(c)));
      if (columnName) {
        newPayload[columnName] = payload[p];
      } else {
        newPayload[p] = payload[p];
      }
    });
    return newPayload;
  }
}
